import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Users, History, BarChart3, Inbox, Settings as SettingsIcon, Mail } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminSubnav() {
  const [pendingCount, setPendingCount] = useState(0);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/admin/reports-pending/count");
        if (active) setPendingCount(data?.count || 0);
      } catch { /* silent */ }
    };
    load();
    const iv = setInterval(load, 30000); // refresh every 30s
    return () => { active = false; clearInterval(iv); };
  }, []);

  const cls = ({ isActive }) =>
    `px-3 py-2 text-sm font-semibold transition-colors border-b-2 flex items-center gap-2 ${
      isActive ? "border-[#002FA7] text-[#0B0F19] dark:text-white" : "border-transparent text-gray-500 hover:text-[#0B0F19] dark:hover:text-white"
    }`;
  return (
    <div className="flex items-center gap-1 mb-6 border-b border-gray-200 dark:border-neutral-700 overflow-x-auto" data-testid="admin-subnav">
      <NavLink to="/admin" end className={cls} data-testid="subnav-users">
        <Users size={14} /> Utilisateurs
      </NavLink>
      <NavLink to="/admin/review" className={cls} data-testid="subnav-review">
        <Inbox size={14} /> À valider
        {pendingCount > 0 && (
          <span
            className="ml-1 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-[10px] font-bold bg-red-500 text-white rounded-full"
            data-testid="subnav-review-badge"
          >
            {pendingCount}
          </span>
        )}
      </NavLink>
      <NavLink to="/admin/stats" className={cls} data-testid="subnav-stats">
        <BarChart3 size={14} /> Statistiques
      </NavLink>
      <NavLink to="/admin/audit" className={cls} data-testid="subnav-audit">
        <History size={14} /> Journal
      </NavLink>
      <NavLink to="/admin/settings" className={cls} data-testid="subnav-settings">
        <SettingsIcon size={14} /> Paramètres
      </NavLink>
      <NavLink to="/admin/email-diagnostic" className={cls} data-testid="subnav-email">
        <Mail size={14} /> Courriels
      </NavLink>
    </div>
  );
}
